/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Card, CardContent, Container, Snackbar, TextField, useMediaQuery, useTheme } from "@mui/material";
import Connexion from "./connexion/Connexion";
import Inscription from "./inscription/Inscription";
import classes from "./style";
import ConnexionMail from "./connexion/connexion-mail";
import InscriptionMail from "./inscription/inscription-mail";
import { TabPanel, a11yProps } from "../../helpers/tabPanels";
import userService from "services/userService";

const ForgotPassword: FC<{}> = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));

  const [email, setEmail] = useState<string>();
  const [emailError, setEmailError] = useState<string | undefined>();
  const [snackMessage, setSnack] = useState<string | undefined>(undefined);

  const reinit = async () => {
    setEmailError(undefined);

    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)) {
      setEmailError("L'adresse email est invalide.");
      return;
    }

    try {
      await userService.forgetPassword(email);
    } catch {
    }

    setSnack("Un mail sera envoyé à cette adresse, si elle est liée à un compte.");
  }

  return (<>
    <Container disableGutters maxWidth={false} sx={classes.authContainer}>
      <Box sx={{ width: isSm ? '80%' : (isMd ? '60%' : null) }}>
        <Card sx={{ ...classes.card, borderTopLeftRadius: "15px !important", height: "320px", position: "relative" }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box sx={{ mt: 2 }}>
              <Typography sx={classes.label}>Mot de passe oublié</Typography>
              <TextField id="outlined-basic" label="Email" value={email} variant="outlined" sx={{ my: 2, width: '100%' }}
                onChange={(e) => setEmail(e.target.value!)} error={emailError ? true : false} helperText={emailError} fullWidth />
            </Box>
            <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained" type="submit" sx={{ mr: 2 }} onClick={() => reinit()}>
                Réinitialiser le mot de passe
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>

    <Snackbar
      open={snackMessage !== undefined ? true : false}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={() => setSnack(undefined)}
      message={snackMessage} />
  </>
  );
};

export default ForgotPassword;
